import {createInjectionState} from '@vueuse/core'
import type {Ref} from 'vue'
import type {RouteLocationNormalizedLoaded} from 'vue-router'

const [useProvideCurrentRoute, useCurrentRoute] = createInjectionState(
  (route: Ref<RouteLocationNormalizedLoaded>) => {
    return {
      route,
    }
  },
)

export {useProvideCurrentRoute, useCurrentRoute}
